import Service from "@ember/service"

export default class MouseDown extends Service {}
